export default {
  lg: 1200,
  md: 992,
  md_max: 1199,
  sm: 768,
  sm_max: 991,
  xs: 480,
  xs_max: 767
}
